// extracted by mini-css-extract-plugin
export var divider = "_2w-0";
export var dividerText = "_2w-1";